module.exports = __webpack_public_path__ + "ee12eae9ea84558856ceffb01673ebd3.svg";